import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCourseStudents } from '../../services/adminInsights.service';

// Jenn, 2026-10-08: "I need to see student progress." Everyone enrolled in this
// course: how far they are, what's next for them, and when they were last in it.
const day = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : '—');

export default function CourseStudents({ courseId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getCourseStudents(courseId).then(setData).catch(() => setError('Could not load students.'));
  }, [courseId]);

  const students = data?.students || [];
  return (
    <div className="mt-8">
      <h2 className="text-base font-bold text-reset-brown mb-3">Students ({data ? students.length : '…'})</h2>
      {error && <p className="text-sm text-gray-600">{error}</p>}
      <div className="bg-white rounded-2xl shadow-sm divide-y divide-gray-50">
        {data && students.length === 0 && <p className="text-sm text-gray-400 px-5 py-6 text-center">Nobody has started this course yet.</p>}
        {students.map(s => {
          const pct = s.lessonCount ? Math.round((s.lessonsDone / s.lessonCount) * 100) : 0;
          return (
            <div key={s.memberId} className="px-5 py-3">
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div className="min-w-0">
                  <Link to={`/admin/members/${s.memberId}`} className="text-sm font-semibold text-reset-brown hover:underline">{s.name}</Link>
                  {s.isStaff && <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full bg-reset-sage/10 text-reset-sage">Team365</span>}
                  {s.isDemo && <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-500">practice</span>}
                  {!s.isActive && <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-500">not active</span>}
                </div>
                <p className="text-xs text-gray-500">{s.lessonsDone} of {s.lessonCount} lessons · {pct}%</p>
              </div>
              <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden mt-2">
                <div className="h-full bg-reset-terracotta rounded-full" style={{ width: `${pct}%` }} />
              </div>
              <p className="text-xs text-gray-400 mt-1.5">
                {s.nextLesson ? <>Next: {s.nextLesson}</> : <>Finished</>}
                {' · '}Started {day(s.enrolledAt)} · Last in the course {day(s.lastAccessedAt)}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
